import CoreModule from './core';

class App {
	constructor() {
		window.addEventListener('load', () => {
			this.coreModule = new CoreModule();
		}, false);
	}
}

const app = new App();